import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppRefreshIndicator from './AppRefreshIndicator';
import { cancelPullRefreshEvent } from '@/services/appPullRefresh';

export default function AppPullRefresh() {
  const { pathname } = useLocation();
  const threshold = 70;
  const [distance, setDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  useEffect(() => {
    setDistance(0);
    setRefreshing(false);
    const hubPage = ['/biz/wifi-module', '/biz/wifi-module/index'].includes(pathname);
    if (!hubPage) return;
    let start = null;
    let pull = 0;
    let frame = null;
    let pending = false;
    const showDistance = (value) => {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        setDistance(value);
      });
    };
    const reset = () => {
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      start = null;
      pull = 0;
      setDistance(0);
    };
    const begin = (event) => {
      reset();
      if (
        pending ||
        event.touches.length !== 1 ||
        event.target.closest(
          'input, textarea, .MuiModal-root, [role="dialog"], [role="slider"], [data-refresh-disabled="true"]'
        )
      )
        return;
      for (let node = event.target; node instanceof Element; node = node.parentElement) {
        if (node.scrollTop > 0) return;
      }
      if (window.scrollY > 0) return;
      start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    };
    const move = (event) => {
      if (event.touches.length !== 1 || event.defaultPrevented) {
        reset();
        return;
      }
      if (!start) return;
      const dy = event.touches[0].clientY - start.y;
      const dx = Math.abs(event.touches[0].clientX - start.x);
      if (dy < 0 || dx > Math.max(12, dy)) {
        reset();
        return;
      }
      pull = Math.min(dy, threshold + 30);
      if (pull > 12) {
        if (event.cancelable) event.preventDefault();
        showDistance(pull);
      } else {
        showDistance(0);
      }
    };
    const end = () => {
      const refresh = pull >= threshold;
      reset();
      if (refresh) {
        pending = true;
        setRefreshing(true);
        window.location.reload();
      }
    };
    document.addEventListener('touchstart', begin, { passive: true });
    document.addEventListener('touchmove', move, { passive: false });
    document.addEventListener('touchend', end);
    document.addEventListener('touchcancel', reset);
    window.addEventListener(cancelPullRefreshEvent, reset);
    return () => {
      if (frame !== null) cancelAnimationFrame(frame);
      document.removeEventListener('touchstart', begin);
      document.removeEventListener('touchmove', move);
      document.removeEventListener('touchend', end);
      document.removeEventListener('touchcancel', reset);
      window.removeEventListener(cancelPullRefreshEvent, reset);
    };
  }, [pathname]);
  return <AppRefreshIndicator distance={distance} refreshing={refreshing} threshold={threshold} />;
}
